import { Box, Heading, Paragraph } from '@zillow/constellation-10';

const WhatArePayments = () => {
  return (
    // oxlint-disable-next-line constellation/no-raw-color-values
    <Box css={{ backgroundColor: '#e2effc', textAlign: 'center', padding: '60px 16px' }}>
      <Box
        css={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          gap: 'default',
          textAlign: 'center',
        }}
      >
        <Heading textStyle="heading-sm" level={2}>
          What are online rent payments?
        </Heading>
        {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 450px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
        <Paragraph css={{ maxWidth: '450px', margin: 'auto' }}>
          Online payments are part of a Zillow service that your landlord uses to manage your rental. You get more
          flexible ways to pay, and you both get more peace of mind.
        </Paragraph>
      </Box>
    </Box>
  );
};

export default WhatArePayments;
